import { AUTH_TOKEN_KEY, USER_DATA_KEY } from './constDictionary'
import { clearData } from '../lib'
import axios from 'axios'
import { redirect } from 'next/navigation'

export function configureAxiosForClient(domain) {
  if (typeof window === 'undefined') {
    console.error(
      'configureAxiosForClient should only be called on the client side.'
    )
    return
  }

  axios.defaults.baseURL = `${domain}/api`

  axios.interceptors.request.use(config => {
    const authToken = localStorage.getItem(AUTH_TOKEN_KEY)
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`
    }

    const updatedConfig = { ...config }
    delete updatedConfig.headers.Host
    delete updatedConfig.headers['Accept-Encoding']

    return updatedConfig
  })

  axios.interceptors.response.use(
    response => response,
    error => {
      const { response = {} } = error
      if (response.status === 401 || response.status === 403) {
        clearData(AUTH_TOKEN_KEY)
        clearData(USER_DATA_KEY)
        redirect('/login')
      }
      return Promise.reject(error)
    }
  )
}
